export const useSxStyles = () => {
  return {
    list: {
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    link: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  };
};
